









import { computed, ComputedRef, defineComponent, getCurrentInstance, onMounted, PropType, watch } from 'vue';
import GlobalSearchFilters from '../components/global_search/GlobalSearchFilters.vue';
import GlobalSearchResults from '../components/global_search/GlobalSearchResults.vue';
import GlobalSearchHeader from '../components/global_search/GlobalSearchHeader.vue';
import { useSearchExecution } from '../composables/global_search/useSearchExecution';
import { types } from '../store/types/types.js';
import { useSearchQuery } from '../composables/global_search/useSearchQuery';
import { docTypes } from '../../shared/enums/docTypes';
import { useSearchFilter } from '../composables/global_search/useSearchFilter';
import GlobalSearchSubFilters from '../components/global_search/GlobalSearchSubFilters.vue';
import GlobalSearchAlert from '../components/global_search/GlobalSearchAlert.vue';

export default defineComponent({
  name: 'GlobalSearch',
  components: {
    GlobalSearchAlert,
    GlobalSearchSubFilters,
    GlobalSearchHeader,
    GlobalSearchResults,
    GlobalSearchFilters,
  },
  props: {
    query: { type: String, default: '' },
    filter: { type: String as PropType<docTypes>, default: null },
  },
  setup(props) {
    const { proxy } = getCurrentInstance();
    const { setQuery } = useSearchQuery();
    const { setActiveFilter } = useSearchFilter();
    const { isLoading, totalCount, initializeSearch } = useSearchExecution();
    const institutionProfileIds: ComputedRef<number[]> = computed(
      () => proxy.$store.getters[types.GET_ACTIVE_INSTITUTIONS_PROFILES]
    );

    const activeChildrenInstitutionProfileIds: ComputedRef<number[]> = computed(
      () => proxy.$store.getters[types.GET_ACTIVE_CHILDREN]
    );

    const populateSearchParams = () => {
      if (totalCount.value > 0 || isLoading.value) {
        return;
      }
      setQuery(props.query);
      setActiveFilter(props.filter);
      initializeSearch();
    };

    onMounted(() => {
      populateSearchParams();
    });

    watch(institutionProfileIds, async () => {
      await initializeSearch();
    });

    watch(activeChildrenInstitutionProfileIds, async () => {
      await initializeSearch();
    });

    return { isLoading };
  },
});
